import beautify from 'js-beautify'

export function beautifyHtml(html: string): string {
    const htmlWithContainer = `<div className="container">${html}</div>`
    const beautified = beautify.html(htmlWithContainer, { indent_size: 1, indent_char: '\t' })
    .replaceAll("\n","<br>").replaceAll("\t","<tab>")
    return beautified
}